<template>
<h1><font-awesome-icon icon="cloud-rain" /></h1>
<u>Regenmesser</u>
<br>
<div v-for="r in rows" :key="r.label" class="row">
  <div class="head">{{ r.label }}: <b>{{ r.text }} mm</b></div>
  <svg viewBox="0 0 200 14" width="200" height="14" xmlns="http://www.w3.org/2000/svg">
    <rect x="0.5" y="0.5" width="199" height="13" rx="6.5" fill="#fbf3dc" stroke="#5b4510" />
    <rect v-if="r.w > 0" x="1" y="1" :width="Math.max(r.w, 12)" height="12" rx="6" fill="#3b82f6" />
  </svg>
  <div class="scale">0 &ndash; {{ r.max }} mm</div>
</div>
<div class="total">Seit 17.4.2025: <b>{{ rain }} mm</b></div>
</template>

<script>
// label, prop and default scale end (mm); the scale grows if a value exceeds it
const PERIODS = [
  { label: 'Diese Stunde', prop: 'rain_h', max: 10, mod: false },
  { label: 'Heute', prop: 'rain_d', max: 30, mod: false },
  { label: 'Diese Woche', prop: 'rain_w', max: 60, mod: true },
  { label: 'Dieser Monat', prop: 'rain_m', max: 150, mod: true }
]

export default {
  name: 'RainMeter',
  props: {
    rain: Number,
    rain_h: Number,
    rain_d: Number,
    rain_w: Number,
    rain_m: Number
  },
  computed: {
    rows() {
      return PERIODS.map(({ label, prop, max, mod }) => {
        const raw = this[prop]
        // week/month values carry an offset of 1000 (kept from the old display)
        const value = Number.isFinite(raw) ? (mod ? raw % 1000 : raw) : null
        const scale = value === null ? max : Math.max(max, Math.ceil(value / max) * max)
        return {
          label,
          max: scale,
          text: value === null ? '--' : (mod ? value.toFixed(1) : value),
          w: value === null ? 0 : Math.min(1, value / scale) * 198
        }
      })
    }
  }
}
</script>

<style scoped>
.row {
  margin-top: 14px;
}

svg {
  display: block;
  margin: 3px auto 0;
}

.scale {
  font-size: 0.7em;
  opacity: 0.8;
}

.total {
  margin-top: 20px;
}
</style>
